<div class="container-fluid">
  <app-content-tab-list activeTab="1" type="ecommerce" category="E-commerce"></app-content-tab-list>

  <div class="row section1 justify-content-between mt-4 ecom-page-header">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">Products ({{filtered.length}})</h5>
        <p class="home-subtitle">Manage physical and downloadable products</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <button type="button" class="btn btn-primary btn-dashboard" (click)="open()"><i class="las la-plus"></i>Add Product</button>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="ecom-card">
        <div class="ecom-filter-title">Filter Products</div>
        <div class="ecom-filters ecom-products-filters">
          <div class="ecom-filter ecom-filter-wide">
            <label class="ecom-label" for="product-search">Keyword</label>
            <input id="product-search" class="form-control" [(ngModel)]="filters.keyword" (keydown)="handleFilterKeydown($event)" placeholder="Product title">
          </div>
          <div class="ecom-filter">
            <label class="ecom-label" for="product-category-filter">Category</label>
            <select id="product-category-filter" class="form-control" [(ngModel)]="filters.category"><option value="">All categories</option>@for (c of categories; track c._id) { <option [value]="c._id">{{c.title}}</option> }</select>
          </div>
          <div class="ecom-filter">
            <label class="ecom-label" for="product-type-filter">Type</label>
            <select id="product-type-filter" class="form-control" [(ngModel)]="filters.type"><option value="">All types</option><option value="physical">Physical</option><option value="downloadable">Downloadable</option></select>
          </div>
          <div class="ecom-filter">
            <label class="ecom-label" for="product-status-filter">Status</label>
            <select id="product-status-filter" class="form-control" [(ngModel)]="filters.status"><option value="">All statuses</option><option value="draft">Draft</option><option value="published">Published</option><option value="archived">Archived</option></select>
          </div>
          <div class="ecom-filter">
            <label class="ecom-label" for="product-currency-filter">Currency</label>
            <select id="product-currency-filter" class="form-control" [(ngModel)]="filters.currency"><option value="">All currencies</option><option value="INR">INR</option><option value="USD">USD</option></select>
          </div>
          <div class="ecom-filter-actions">
            <button type="button" class="btn ecom-filter-apply" (click)="applyFilters()">Apply Filters</button>
            @if (hasActiveFilters()) {
              <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">Reset</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead><tr><th>Product</th><th>Category</th><th>Type</th><th>Price</th><th>Inventory</th><th>Status</th><th>Actions</th></tr></thead>
          @if (!loading && filtered.length) {
            <tbody>
              @for (item of filtered; track item._id) {
                <tr>
                  <td><div class="d-flex align-items-center"><img class="ecom-thumb mr-3" [src]="item.thumbnailUrl || 'assets/images/placeholder.png'" onerror="this.src='assets/images/placeholder.png'" alt=""><div class="ecom-item-title">{{item.title}}</div></div></td>
                  <td>{{item.category?.title || '—'}}</td>
                  <td class="text-capitalize">{{item.productType}}</td>
                  <td>{{money(item.priceMinor, item.currency)}}</td>
                  <td>{{item.productType === 'downloadable' || !item.trackInventory ? 'Unlimited' : item.stockQuantity}}</td>
                  <td><span class="ecom-status" [ngClass]="item.status">{{item.status}}</span></td>
                  <td class="action">
                    <div class="dropdown ecom-action-menu">
                      <button type="button" class="btn btn-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="text-primary text-nowrap">View actions <i class="las la-angle-down align-middle"></i></span></button>
                      <div class="dropdown-menu dropdown-menu-right py-0">
                        <button type="button" class="dropdown-item text-info border-bottom py-2" (click)="open(item)"><i class="las la-edit la-lg align-middle"></i> Edit</button>
                        <button type="button" class="dropdown-item text-danger py-2" (click)="remove(item)"><i class="las la-trash-alt la-lg align-middle"></i> Delete</button>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
      @if (!loading && !filtered.length) { <div class="ecom-empty">No products found</div> }
    </div>
  </div>
</div>

@if (showModal) {
  <div class="modal fade show ecom-modal ecom-product-modal" tabindex="-1" role="dialog" (click)="close()">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{editId ? 'Edit' : 'Add'}} Product</h5>
          <button type="button" class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-lg-6">
              <label class="ecom-label" for="product-category">Category <span class="required">*</span></label>
              <select id="product-category" class="form-control" [(ngModel)]="form.categoryId"><option value="">Select category</option>@for (c of categories; track c._id) { <option [value]="c._id">{{c.title}}</option> }</select>
            </div>
            <div class="col-12 col-lg-6 mt-3 mt-lg-0">
              <label class="ecom-label" for="product-type">Product type <span class="required">*</span></label>
              <select id="product-type" class="form-control" [(ngModel)]="form.productType"><option value="physical">Physical product</option><option value="downloadable">Downloadable product</option></select>
            </div>
            <div class="col-12 mt-3">
              <label class="ecom-label" for="product-title">Title <span class="required">*</span></label>
              <input id="product-title" class="form-control" [(ngModel)]="form.title" placeholder="Enter product title">
            </div>
            <div class="col-12 mt-3">
              <label class="ecom-label" for="product-description">Description <span class="required">*</span></label>
              <textarea id="product-description" class="form-control" rows="4" [(ngModel)]="form.description" placeholder="Enter product description"></textarea>
            </div>
            <div class="col-12 col-md-2 mt-3">
              <label class="ecom-label" for="product-currency">Currency</label>
              <select id="product-currency" class="form-control" [(ngModel)]="form.currency"><option value="INR">INR</option><option value="USD">USD</option></select>
            </div>
            <div class="col-12 col-md-3 mt-3">
              <label class="ecom-label" for="product-price">Price <span class="required">*</span></label>
              <input id="product-price" type="number" min="0" step="0.01" class="form-control" [(ngModel)]="form.price">
            </div>
            <div class="col-12 col-md-3 mt-3">
              <label class="ecom-label" for="product-status">Status</label>
              <select id="product-status" class="form-control" [(ngModel)]="form.status"><option value="draft">Draft</option><option value="published">Published</option><option value="archived">Archived</option></select>
            </div>
            <div class="col-12 col-md-4 mt-3 ecom-thumbnail-field">
              <span class="ecom-label">Thumbnail <span class="required">*</span></span>
              <div class="ecom-thumbnail-actions">
              <label class="ecom-upload ecom-upload-compact" for="product-thumbnail-upload">
                <img class="ecom-upload-preview" [src]="form.thumbnailUrl || 'assets/images/placeholder.png'" onerror="this.src='assets/images/placeholder.png'" alt="Thumbnail preview">
                <span class="ecom-upload-copy"><strong>{{form.thumbnailUrl ? 'Change' : 'Upload thumbnail'}}</strong></span>
              </label>
              <input id="product-thumbnail-upload" type="file" accept="image/*" class="d-none" (change)="upload($event, 'thumbnail')">
              @if (form.thumbnailUrl) { <a class="ecom-thumbnail-view" [href]="form.thumbnailUrl" target="_blank" rel="noopener noreferrer" aria-label="View thumbnail"><i class="las la-external-link-alt"></i> View</a> }
              </div>
            </div>
          </div>

          <div class="ecom-optional-stack">
            <details class="ecom-optional-panel">
              <summary>Gallery <i class="las la-angle-down"></i></summary>
              <div class="ecom-optional-body">
                <label class="ecom-upload" for="product-gallery-upload"><span class="ecom-upload-copy"><strong>Add gallery images</strong>Select one or more PNG, JPG or WebP files</span></label>
                <input id="product-gallery-upload" type="file" multiple accept="image/*" class="d-none" (change)="upload($event, 'gallery')">
                @if (form.galleryUrls.length) {
                  <div class="ecom-gallery mt-3">@for (url of form.galleryUrls; track url; let i = $index) { <div class="ecom-gallery-item"><img class="ecom-thumb" [src]="url" alt=""><button type="button" aria-label="Remove image" (click)="removeGallery(i)">&times;</button></div> }</div>
                }
              </div>
            </details>

            @if (form.productType === 'downloadable') {
              <details class="ecom-optional-panel" open>
                <summary>Downloadable file <i class="las la-angle-down"></i></summary>
                <div class="ecom-optional-body">
                  <div class="ecom-upload ecom-download-upload">
                    <div class="ecom-download-actions">
                      <label class="ecom-download-action" for="product-download-upload">{{form.downloadFile ? 'Replace file' : 'Choose download file *'}}</label>
                      @if (form.downloadFile?.key) { <span class="ecom-download-divider">|</span><button type="button" class="ecom-download-action" (click)="viewDownloadFile()">View uploaded file</button> }
                    </div>
                    <span class="ecom-download-filename">{{form.downloadFile?.filename || 'Upload the file customers will receive'}}</span>
                  </div>
                  <input id="product-download-upload" type="file" class="d-none" (change)="upload($event, 'download')">
                </div>
              </details>
            }

            @if (form.productType === 'physical') {
              <details class="ecom-optional-panel">
                <summary>Inventory &amp; shipping <i class="las la-angle-down"></i></summary>
                <div class="ecom-optional-body"><div class="row">
                  <div class="col-12 mb-3"><label class="ecom-checkbox"><input type="checkbox" [(ngModel)]="form.trackInventory"> Track inventory</label></div>
                  <div class="col-12 col-md-4"><label class="ecom-label" for="product-stock">Stock quantity</label><input id="product-stock" type="number" min="0" class="form-control" [(ngModel)]="form.stockQuantity" [disabled]="!form.trackInventory"></div>
                  <div class="col-12 col-md-4 mt-3 mt-md-0"><label class="ecom-label" for="product-shipping">Shipping charge</label><input id="product-shipping" type="number" min="0" step="0.01" class="form-control" [(ngModel)]="form.shippingCharge"></div>
                  <div class="col-12 col-md-4 mt-3 mt-md-0"><label class="ecom-label" for="product-tax">Tax rate (%)</label><input id="product-tax" type="number" min="0" max="100" class="form-control" [(ngModel)]="form.taxRate"></div>
                  <div class="col-12 col-md-4 mt-3"><label class="ecom-label" for="product-weight">Weight</label><div class="input-group"><input id="product-weight" type="number" min="0" class="form-control" [(ngModel)]="form.weight"><select class="form-control" aria-label="Weight unit" [(ngModel)]="form.weightUnit"><option value="g">g</option><option value="kg">kg</option><option value="oz">oz</option><option value="lb">lb</option></select></div></div>
                  <div class="col-12 col-md-2 mt-3"><label class="ecom-label" for="product-length">Length</label><input id="product-length" type="number" min="0" class="form-control" [(ngModel)]="form.dimensions.length"></div>
                  <div class="col-12 col-md-2 mt-3"><label class="ecom-label" for="product-width">Width</label><input id="product-width" type="number" min="0" class="form-control" [(ngModel)]="form.dimensions.width"></div>
                  <div class="col-12 col-md-2 mt-3"><label class="ecom-label" for="product-height">Height</label><input id="product-height" type="number" min="0" class="form-control" [(ngModel)]="form.dimensions.height"></div>
                  <div class="col-12 col-md-2 mt-3"><label class="ecom-label" for="product-unit">Unit</label><select id="product-unit" class="form-control" [(ngModel)]="form.dimensions.unit"><option value="cm">cm</option><option value="in">in</option></select></div>
                </div></div>
              </details>
            }

            <details class="ecom-optional-panel">
              <summary>Publishing options <i class="las la-angle-down"></i></summary>
              <div class="ecom-optional-body"><div class="row">
                <div class="col-12 col-md-4"><label class="ecom-label" for="product-order">Display order</label><input id="product-order" type="number" min="0" class="form-control" [(ngModel)]="form.sortOrder"></div>
                <div class="col-12 col-md-8 mt-3 mt-md-0"><label class="ecom-label" for="product-slug">Slug (optional)</label><input id="product-slug" class="form-control" [(ngModel)]="form.slug" placeholder="Generated from title"></div>
              </div></div>
            </details>
          </div>
        </div>
        <div class="modal-footer">
          <span class="mr-auto text-muted">{{uploading ? 'Uploading...' : ''}}</span>
          <button type="button" class="btn btn-outline-secondary" (click)="close()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="saving || uploading" (click)="save()">{{saving ? 'Saving...' : (editId ? 'Save Changes' : 'Add Product')}}</button>
        </div>
      </div>
    </div>
  </div>
}

@if (showThumbnailCropModal) {
  <div class="modal fade show ecom-modal ecom-crop-modal" tabindex="-1" role="dialog" (click)="closeThumbnailCropModal()">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <div><h5 class="modal-title">Crop product thumbnail</h5><small class="text-muted">Square crop</small></div>
          <button type="button" class="close" aria-label="Close" [disabled]="uploading" (click)="closeThumbnailCropModal()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body ecom-crop-body">
          <image-cropper
            [imageFile]="thumbnailImageFile"
            [maintainAspectRatio]="true"
            [aspectRatio]="thumbnailAspectRatio"
            format="png"
            [imageQuality]="100"
            [resizeToWidth]="1200"
            (imageCropped)="onThumbnailImageCropped($event)"
            (loadImageFailed)="onThumbnailImageLoadFailed()"></image-cropper>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" [disabled]="uploading" (click)="closeThumbnailCropModal()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="uploading || !croppedThumbnailFile" (click)="uploadCroppedThumbnail()">{{uploading ? 'Uploading...' : 'Crop & Upload'}}</button>
        </div>
      </div>
    </div>
  </div>
}

@if (showGalleryCropModal) {
  <div class="modal fade show ecom-modal ecom-crop-modal" tabindex="-1" role="dialog" (click)="closeGalleryCropModal()">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <div><h5 class="modal-title">Crop gallery image</h5><small class="text-muted">Image {{galleryCropTotal - galleryCropQueue.length}} of {{galleryCropTotal}} · Square crop</small></div>
          <button type="button" class="close" aria-label="Close" [disabled]="uploading" (click)="closeGalleryCropModal()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body ecom-crop-body">
          <image-cropper
            [imageFile]="galleryImageFile"
            [maintainAspectRatio]="true"
            [aspectRatio]="galleryAspectRatio"
            format="png"
            [imageQuality]="100"
            [resizeToWidth]="1200"
            (imageCropped)="onGalleryImageCropped($event)"
            (loadImageFailed)="onGalleryImageLoadFailed()"></image-cropper>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" [disabled]="uploading" (click)="closeGalleryCropModal()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="uploading || !croppedGalleryFile" (click)="uploadCroppedGallery()">{{uploading ? 'Uploading...' : (galleryCropQueue.length ? 'Crop & Next' : 'Crop & Upload')}}</button>
        </div>
      </div>
    </div>
  </div>
}
